import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import InputFormat from "../../../partials/inputForm";
import LabelForm from "../../../partials/labelForm";
import { _parsePhoneNumber } from "../../../partials/validateNumber";
import { getOriginalImage } from "../../../utils/setting";
import CountryCode from "../../countryCode";
import InputFileReader from "../../fileReader";
import ImageGallery from "../../imageGallery";
import MapComponent from "../../leafletMap";
import Loading from "../../loading";
import Snackbar from "../../snackbar";
import InputAddress from "../../suggestAddress";
import { textFieldStyles } from "./styles";

class EditService extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      colorSnackbar: "",
      checkValidate: "",
      branch: {
        branchName: "",
        address: "",
        addressData: "",
        phone: "",
        mobile: "",
        countryCode: "",
        lat: 0,
        lng: 0,
        city: "hochiminh",
        district: "",
      },
      imageGallery: [],
      // lat_center: 10.797336,
      // lng_center: 106.679428,
      // lat_location: "",
      // lng_location: "",
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    this.setState({
      branch: {
        ...this.props.branch,
        addressData: this.props.branch && this.props.branch.address,
      },
    });
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.branch !== nextProps.branch) {
      this.setState({
        branch: {
          ...nextProps.branch,
          addressData: nextProps.branch && nextProps.branch.address,
        },
      });
    }
  }
  handleChangeAddress = (value) => {
    let { branch } = this.state;
    branch = { ...branch, ...value };
    this.setState({ branch });
  };
  handleChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    let branch = this.state.branch;
    branch[name] = value;
    this.setState({ branch });
  };

  handleSubComponentChange = (name, value) => {
    // let nameEdit = (name === "lat") ? "lat" : (name === "lng") ? "lng" : "countryCode"
    let branch = this.state.branch;
    branch[name] = value;
    this.setState({ branch });
  };

  async handleSubmit() {
    this.loading.startLoading();
    let { branch } = this.state;
    let { t } = this.props;
    if (!branch.branchName) {
      this.props.handleOpenSnackBar(
        t("servicebranch_createbranch_fill_in_branch_name"),
        "warning"
      );
    } else if (!branch.mobile) {
      this.props.handleOpenSnackBar(
        t("servicebranch_createbranch_fill_in_branch_mobile"),
        "warning"
      );
    } else if (!branch.addressData) {
      this.props.handleOpenSnackBar(
        t("servicebranch_createbranch_fill_in_branch_address"),
        "warning"
      );
    } else if (!branch.address) {
      this.props.handleOpenSnackBar(
        t("servicebranch_createbranch_fill_in_branch_address_to_show_on_map"),
        "warning"
      );
    } else if (!_parsePhoneNumber(branch.countryCode, branch.mobile).isValid) {
      this.props.handleOpenSnackBar(
        t("servicebranch_createbranch_please_enter_valid_phone"),
        "warning"
      );
    } else {
      await this.myGoogleMap.viewOnGoogleMap(branch.address);
      if (!this.myGoogleMap.state.checked) {
        this.props.handleOpenSnackBar(
          t("servicebranch_createbranch_address_invalid"),
          "warning"
        );
      } else {
        let check;
        if (this.InputFileReader.getFlagEdit()) {
          let files = this.InputFileReader.getFile();
          let src = this.InputFileReader.getSrc();
          if (files !== null) {
            check = await this.props.uploadDispatch.saveStorage({
              files: files,
              code: branch.serviceCode,
              imgPre: branch.imageUrl,
              type: "img-branch",
            });
            if (check && check.code === 1) {
              branch.imageUrl = check.data.previewLink;
            }
          } else if (src !== null) {
            branch.imageUrl = src;
          } else {
            if (branch.imageUrl) {
              branch.imageUrl = "";
            }
          }
        }
        branch.address = branch.addressData || "";
        branch.lat = branch.lat || "";
        branch.lng = branch.lng || "";
        delete branch.addressData;
        check = await this.props.handleSubmitUpdate(branch);
      }
    }
    this.loading.stopLoading();
  }
  handleSelectImage = async (data) => {
    let { t } = this.props;
    this.loading.startLoading();
    let checkUpload = await this.props.uploadDispatch.saveStorage({
      files: data.e.target.files[0],
      code: this.props.serviceCode,
      type: "img-branch",
    }); // serviceCode lấy từ roleId
    this.loading.stopLoading();
    if (checkUpload.code === 1) {
      let imageGallery = data.imageGallery.map((e) => getOriginalImage(e));
      imageGallery.push(checkUpload.data.previewLink);
      // this.setState({imageGallery})
      this.updateImageGallery(imageGallery);
    } else
      this.mSnackbar.handleClick(
        t("service_ownerspa_service_album_create_album_unsuccess"),
        "error"
      );
  };

  deleteImage = async (data) => {
    let imageGallery = data.imageGallery;
    let position = -1;
    imageGallery.forEach((image, index) => {
      if (image === data.imageDelete) position = index;
    });
    if (position !== -1) imageGallery.splice(position, 1);
    this.updateImageGallery(imageGallery);
  };
  updateImageGallery = async (imageGallery) => {
    let { t } = this.props;
    this.loading.startLoading();
    imageGallery = imageGallery.map((e) => getOriginalImage(e));
    let data = {
      // serviceCode: this.state.branch.serviceCode,
      branchCode: this.state.branch.branchCode,
      imageGallery: JSON.stringify(imageGallery),
    };
    let check = await this.props.serviceBranchDispatch.updateImageGallery(data);
    this.loading.stopLoading();
    if (check.code === 1) {
      this.mSnackbar.handleClick(
        t("voucher_addvoucher_upload_image_in_gallery_successfully")
      );
      this.props.finishUpdateImageGallery();
    } else {
      this.mSnackbar.handleClick(
        t("voucher_addvoucher_upload_image_in_gallery_unsuccessfully") +
          " " +
          check.message,
        "error"
      );
    }
  };

  onEnterAddress = (event) => {
    if (event.key === "Enter") {
      const { branch = {} } = this.state;
      this.myGoogleMap.viewOnGoogleMap(branch.address);
    }
  };
  render() {
    const { classes, t, role, ownerCode } = this.props;
    const { branch = {} } = this.state;
    if (Object.keys(branch).length > 0) {
      return (
        <form className={classes.container} noValidate autoComplete="off">
          <Loading onRef={(id) => (this.loading = id)} />
          <Snackbar onRef={(snackbar) => (this.mSnackbar = snackbar)} />
          <Grid container spacing={3}>
            <Grid item xs={12} sm={4}>
              <InputFormat
                label={t("servicebranch_editbranch_branch_name")}
                name="branchName"
                value={branch.branchName || ""}
                onChange={this.handleChange}
                fullWidth={true}
              />
            </Grid>
            <Grid item xs={12} sm={4} className={classes.containerMobile}>
              <Grid
                container
                spacing={1}
                justify="center"
                alignItems="flex-end"
              >
                <Grid item xs={4} sm={4}>
                  <CountryCode
                    code={branch.countryCode}
                    handleCountryCode={this.handleSubComponentChange}
                  />
                </Grid>
                <Grid item xs={8} sm={8}>
                  <InputFormat
                    required
                    label={t("servicebranch_editbranch_mobile")}
                    name="mobile"
                    value={branch.mobile || ""}
                    onChange={this.handleChange}
                    fullWidth={true}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={4}>
              <InputFormat
                label={t("servicebranch_editbranch_phone")}
                name="phone"
                value={branch.phone || ""}
                onChange={this.handleChange}
                fullWidth={true}
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <InputFormat
                required
                label={t("servicebranch_editbranch_address")}
                name="addressData"
                value={branch.addressData || ""}
                onChange={this.handleChange}
                fullWidth={true}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <InputAddress
                required
                label={t("servicebranch_editbranch_suggest_address")}
                name="address"
                onKeyPress={this.onEnterAddress}
                value={branch.address || ""}
                handleChange={this.handleChangeAddress}
                fullWidth={true}
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              <InputFormat
                required
                disabled
                label={t("servicebranch_editbranch_longitude")}
                name="country"
                value={branch.lng || ""}
                fullWidth={true}
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              <InputFormat
                required
                disabled
                label={t("servicebranch_editbranch_latitude")}
                name="country"
                value={branch.lat || ""}
                fullWidth={true}
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              <InputFormat
                disabled
                label={t("service_ownerspa_servicedetail_feature_country")}
                name="country"
                value={branch.country || ""}
                fullWidth={true}
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              <InputFormat
                disabled
                label={t("service_ownerspa_servicedetail_feature_state")}
                name="state"
                value={branch.state || ""}
                fullWidth={true}
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              <InputFormat
                disabled
                label={t("service_ownerspa_servicedetail_feature_city")}
                name="city"
                value={branch.city || ""}
                fullWidth={true}
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              <InputFormat
                disabled
                label={t("service_ownerspa_servicedetail_feature_district")}
                value={branch.district || ""}
                name="district"
                fullWidth={true}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <MapComponent
                style={{ margin: 0 }}
                onRef={(googleMap) => (this.myGoogleMap = googleMap)}
                handleChangeAddress={this.handleChangeAddress}
                handleOpenSnackBar={this.props.handleOpenSnackBar}
                lat_center={Number(branch.lat || 0)}
                lng_center={Number(branch.lng || 0)}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={8}>
              <LabelForm label={t("image_of_branch")} />
              <InputFileReader
                onRef={(id) => (this.InputFileReader = id)}
                defaultImg={branch.imageUrl}
                style={classes}
                container="square"
                selectStorageMode={true}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <LabelForm label={t("voucher_image_gallery")} />
              <ImageGallery
                imageGallery={branch.imageGallery}
                handleSelectImage={this.handleSelectImage}
                deleteImage={this.deleteImage}
                updateImageGallery={this.updateImageGallery}
              />
            </Grid>
          </Grid>

          <Grid container spacing={0} justify="flex-end">
            <Button
              disabled={role === "admin" && ownerCode}
              onClick={this.handleSubmit}
              color="primary"
              variant="contained"
              component="span"
              className={classes.button}
            >
              {t("servicebranch_editbranch_save")}
            </Button>
          </Grid>
        </form>
      );
    } else {
      return <div></div>;
    }
  }
}

EditService.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapState = (state) => ({
  serviceCode: state.user.user.roleId.serviceCode,
  role: state.user.user.roleId.role,
  ownerCode: state.service.service.userCode,
});

const mapDispatch = (dispatch) => ({
  serviceBranchDispatch: dispatch.serviceBranch,
  uploadDispatch: dispatch.upload,
});

export default connect(
  mapState,
  mapDispatch
)(translate("translations")(withStyles(textFieldStyles)(EditService)));
